import React from 'react';


const IconArchiveMenu: React.FC = () => (
    <svg className="icon-main-menu" width="17" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M8 15V12H10V13H14V12H16V15H8ZM19 10H5V18H19V10ZM21 9V20H3V9L5 5H19L21 9ZM18.2639 8H5.73607L6.23607 7H17.7639L18.2639 8Z"/>
    </svg>
);

export default IconArchiveMenu;